import { z } from 'zod';
import { endpoint } from './endpoint.js';
import {
  BulkDownloadManifestRequestSchema,
  BulkDownloadManifestResponseSchema,
} from '../schemas/bulk-download-manifest.js';
import { AttachmentUploadResponseSchema } from '../schemas/attachments.js';

const AttachmentOwnerParamsSchema = z.object({ id: z.coerce.number().int().positive() });

export const mediaUnitAttachments = {
  bulkDownloadManifest: endpoint(
    'POST',
    '/media-units/attachments/bulk-download-manifest',
    BulkDownloadManifestRequestSchema,
    BulkDownloadManifestResponseSchema,
  ),
  upload: endpoint(
    'POST',
    '/media-units/:id/attachments',
    AttachmentOwnerParamsSchema,
    AttachmentUploadResponseSchema,
  ),
  delete: endpoint(
    'DELETE',
    '/media-units/:id/attachments/:attachmentId',
    AttachmentOwnerParamsSchema.extend({ attachmentId: z.coerce.number().int().positive() }),
    z.void(),
  ),
};
